import Vue from 'vue';
import cookieconsent from 'vue-cookieconsent-component';

Vue.component('cookie-consent', cookieconsent)